<div class="connessione">
    <span>
        <i
          [ngStyle]="{
                color: (isConnected$ | async) ? 'green' : 'red'
            }"
          id="iconWifi"
          class="bi bi-circle-fill status-connection"
        ></i>
    </span>
  <span class="ml-2">&nbsp;{{ (isConnected$ | async) ? 'Online' : 'Offline' }}</span>
</div>

<div class="go-top" (click)="goTop()">
  <i class="bi bi-arrow-up-circle-fill custom-font"></i>
</div>
<div *ngIf="isInstantSaveVisible()" class="instant-save pt-2" (click)="instantSave()">
  <i class="bi bi bi-cloud-upload-fill custom-font2"></i>
</div>
<div class="go-to-list" *ngIf="!isInstantSaveVisible()" [routerLink]="['/prese-in-carico']" routerLinkActive="d-none"
     [routerLinkActiveOptions]="{ exact: true }">
  <i class="bi bi-list-ul custom-font"></i>
</div>
<div *ngIf="isInstantPrintVisible()" class="instant-print pt-2" (click)="instantPrint()">
  <i class="bi bi-printer-fill custom-font2"></i>
</div>

<footer class="d-grid footer bg-footer">
  <div class="container container-fluid">
    <div class="d-flex flex-row justify-content-between">
      <div class="col-4 text-center mt-4">
        <small>© CONFCOOPERATIVE - CF:80156250583</small>
      </div>
      <div class="col-4 text-center mt-4">servizio offerto da</div>
      <div class="col-4 text-center mt-4">
        <button disabled class="btn btn-blue ml-100" href="#">CONTATTA L'HELPDESK</button>
      </div>
    </div>
    <div class="text-center pb-3 mb-3">
      <a href="http://www.node.coop" target="_blank"> <img src="../../assets/images/node.png"/></a>
    </div>
  </div>
</footer>
